export type ListViewEntry = { id: number };

/** Base for immutable list Views: keyed lookup on top of the ordered `list`. */
abstract class AbstractListView<Item extends ListViewEntry> {
	readonly list: readonly Item[];
	protected readonly hashMap: Map<number, Item>;
	private readonly className: string;

	protected constructor(list: readonly Item[], className: string) {
		this.list = list;
		this.className = className;
		this.hashMap = new Map();

		for (const item of list) {
			this.hashMap.set(item.id, item);
		}
	}

	findById(id: number | null): Item | null {
		if (id === null) {
			return null;
		}

		return this.hashMap.get(id) ?? null;
	}

	getById(id: number): Item {
		const item = this.hashMap.get(id);

		if (!item) {
			throw new Error(`${this.className} with id ${id} not found`);
		}

		return item;
	}
}

export default AbstractListView;
